// object index: optionName_year or optionKey (2223) for mapping for dropdown and year specific
// key: description value for audit history
export default {
        "option-I-32_2425": {
                key: 'option-I-32',
                N: 'Private rate',
                1: 'Public rate',
                2: 'Blended rate'
        },
        "option-I-32_2324": {
                key: 'option-I-32',
                N: 'Private rate',
                1: 'Public rate',
                2: 'Blended rate'
        },
        "option-I-32_2223": {
                key: 'option-I-32',
                N: 'Private rate',
                1: 'Public rate',
                2: 'Blended rate'
        },
        "option-I-28_2425":{
                key: "option-I-28",
                1: 'No',
                2: 'Yes'
        },
        "option-I-28_2324":{
                key: "option-I-28",
                1: 'No',
                2: 'Yes'
        },
        "option-I-28_2223":{
                key: "option-I-28",
                1: 'No',
                2: 'Yes'
        },
        "option-E-2a_2425":{
                key: "option-E-2a",
                1: 'No',
                2: 'Yes'
        },
        "option-E-2a_2324":{
                key: "option-E-2a",
                1: 'No',
                2: 'Yes'
        },
        "option-E-2a_2223":{
                key: "option-E-2a",
                1: 'No',
                2: 'Yes'
        },
        "option-E-2b_2425":{
                key: "option-E-2b",
                1: 'No',
                2: 'Yes'
        },
        "option-E-2b_2324":{
                key: "option-E-2b",
                1: 'No',
                2: 'Yes'
        },
        "option-E-2b_2223":{
                key: "option-E-2b",
                1: 'No',
                2: 'Yes'
        },
        "AnnualSavingGoals-Parent_2425": {
                key: 'Define Annual Saving Goal Rate',
                Y: 'Private rate',
                1: 'Public rate',
                2: 'Blended rate'
        },
        "AnnualSavingGoals-Parent_2324": {
                key: 'Define Annual Saving Goal Rate',
                Y: 'Private rate',
                1: 'Public rate',
                2: 'Blended rate'
        },
        "AnnualSavingGoals-Parent_2223": {
                key: 'Define Annual Saving Goal Rate',
                Y: 'Private rate',
                1: 'Public rate',
                2: 'Blended rate'
        },
        "AnnualSavingGoals-Parent_2021": {
                key: 'Define Annual Saving Goal Rate',
                Y: 'Private rate',
                1: 'Public rate',
                2: 'Blended rate'
        },
        "AnnualSavingGoals-Parent_2020": {
                key: 'Define Annual Saving Goal Rate',
                Y: 'Private rate',
                1: 'Public rate',
                2: 'Blended rate'
        },
        "AnnualSavingGoals-Parent_2019": {
                key: 'Define Annual Saving Goal Rate',
                Y: 'Private rate',
                1: 'Public rate',
                2: 'Blended rate'
        },
        "DefineAnnualSavingGoalRate_2021": {
                key: 'Define Annual Saving Goal Rate',
                Y: 'Private rate',
                1: 'Public rate',
                2: 'Blended rate'
        },
        "DefineAnnualSavingGoalRate_2020": {
                key: 'Define Annual Saving Goal Rate',
                Y: 'Private rate',
                1: 'Public rate',
                2: 'Blended rate'
        },
        "DefineAnnualSavingGoalRate_2019": {
                key: 'Define Annual Saving Goal Rate',
                Y: 'Private rate',
                1: 'Public rate',
                2: 'Blended rate'
        },
        "option-I-16a_2425": {
                key: 'Select Calculation Type - Parent',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Higher of Reported\/Projected'
        },
        "option-I-16a_2324": {
                key: 'Select Calculation Type - Parent',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Higher of Reported\/Projected'
        },
        "option-I-16a_2223": {
                key: 'Select Calculation Type - Parent',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Higher of Reported\/Projected'
        },
        "option-I-16b_2425": {
                key: 'Select Calculation Type - Parent',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Higher of Reported\/Projected'
        },
        "option-I-16b_2324": {
                key: 'Select Calculation Type - Parent',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Higher of Reported\/Projected'
        },
        "option-I-16b_2223": {
                key: 'Select Calculation Type - Parent',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Higher of Reported\/Projected'
        },
        "SelectCalculationType-Parent_2021": {
                key: 'Select Calculation Type - Parent',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Projected with Tolerance',
                4: 'Use Higher of Reported\/Projected',
                5: 'Use alternate home value calculation'
        },
        "SelectCalculationType-Parent_2020": {
                key: 'Select Calculation Type - Parent',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Projected with Tolerance',
                4: 'Use Higher of Reported\/Projected',
                5: 'Use alternate home value calculation'
        },
        "SelectCalculationType-Parent_2019": {
                key: 'Select Calculation Type - Parent',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Projected with Tolerance',
                4: 'Use Higher of Reported\/Projected',
                5: 'Use alternate home value calculation'
        },
        "SetHomeValue_2021": {
                key: 'Set Home Value',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Projected with Tolerance',
                4: 'Use Higher of Reported\/Projected',
                5: 'Use alternate home value calculation'
        },
        "SetHomeValue_2020": {
                key: 'Set Home Value',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Projected with Tolerance',
                4: 'Use Higher of Reported\/Projected',
                5: 'Use alternate home value calculation'
        },
        "SetHomeValue_2019": {
                key: 'Set Home Value',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Projected with Tolerance',
                4: 'Use Higher of Reported\/Projected',
                5: 'Use alternate home value calculation'
        },
        "SelectCalculationType-IndependentStudent_2021": {
                key: 'Select Calculation Type - Independent Student',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Projected with Tolerance',
                4: 'Use Higher of Reported\/Projected',
                5: 'Use alternate home value calculation'
        },
        "SelectCalculationType-IndependentStudent_2020": {
                key: 'Select Calculation Type - Independent Student',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Projected with Tolerance',
                4: 'Use Higher of Reported\/Projected',
                5: 'Use alternate home value calculation'
        },
        "SelectCalculationType-IndependentStudent_2019": {
                key: 'Select Calculation Type - Independent Student',
                1: 'Use Reported',
                2: 'Use Projected',
                3: 'Use Projected with Tolerance',
                4: 'Use Higher of Reported\/Projected',
                5: 'Use alternate home value calculation'
        },
        "ProjectParentAssets_2021": {
                key: 'Project Parent Assets',
                C: 'Yes',
                N: 'No'
        },
        "ProjectParentAssets_2020": {
                key: 'Impute Parent Assets',
                C: 'Yes',
                N: 'No'
        },
        "ProjectParentAssets_2019": {
                key: 'Impute Parent Assets',
                C: 'Yes',
                N: 'No'
        },
        "ProjectDependentStudentAssets_2021": {
                key: 'Project DepStudent Assets',
                C: 'Yes',
                N: 'No'
        },
        "ProjectDependentStudentAssets_2020": {
                key: 'Project DepStudent Assets',
                C: 'Yes',
                N: 'No'
        },
        "ProjectDependentStudentAssets_2019": {
                key: 'Project DepStudent Assets',
                C: 'Yes',
                N: 'No'
        },
        "ProjectIndependentStudentAssets_2021": {
                key: 'Project IndepStudent Assets',
                C: 'Yes',
                N: 'No'
        },
        "ProjectIndependentStudentAssets_2020": {
                key: 'Project IndepStudent Assets',
                C: 'Yes',
                N: 'No'
        },
        "ProjectIndependentStudentAssets_2019": {
                key: 'Project IndepStudent Assets',
                C: 'Yes',
                N: 'No'
        },
        "ProjectAssets_2021": {
                key: 'Project Assets',
                C: 'Yes',
                N: 'No'
        },
        "ImputeAssets_2020": {
                key: 'Impute Assets',
                C: 'Yes',
                N: 'No'
        },
        "ImputeAssets_2019": {
                key: 'Impute Assets',
                C: 'Yes',
                N: 'No'
        },
        Y: "Yes",
        N: "No",
        NPC: "Net Price Calculator",
        PROFILE: "CSS Profile",
        POWERFAIDS: "PowerFAIDS cloud",
        ORACLE: "Oracle",
        SIGMA: "Sigma Pro Sam"
};
